/**
 * Returns `true` if URL appears to be a separate site.
 */
export const isExternalUrl = (url: string) => /^https?:\/\//i.test(url);
